<template>
	<component
		v-bind:is="tag || 'p'"
		:class="classString"
		:element-translation="i18n ? elementTranslation.found : elementTranslation.missing"
		v-html="translatedContent"
	></component>
</template>

<script>
import { elementTranslation } from '../../tools/consts';
import { i18n } from '../../tools/i18n';
export default {
	props: {
		content: String,
		i18n: Boolean,
		html: String,
		name: String,
		tag: String,
		modifier: String,
		bold: Boolean,
		italic: Boolean,
	},
	computed: {
		translatedContent() {
			return `${this.bold ? '<b>' : ''}${this.italic ? '<i>' : ''}${
				this.i18n ? i18n.t(this.content) : this.content
			}${this.italic ? '<i>' : ''}${this.bold ? '</b>' : ''}`;
		},
		classString() {
			return `element element--${this.modifier || 'text'} ${
				this.name ? `element--${this.modifier || 'text'}--${name}` : ''
			}`;
		},
	},
	created() {
		this.elementTranslation = elementTranslation;
	},
};
</script>
